// Programmatic scrolls pass an explicit behavior, which overrides CSS `scroll-behavior` (#374). Under reduced
// motion this is 'instant', not 'auto': 'auto' defers to the computed CSS value, which may still be smooth.

export function preferredScrollBehavior(): 'instant' | 'smooth' {
  const reducedMotion =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  return reducedMotion ? 'instant' : 'smooth'
}
